<template>
<div ref="el" data-component="TimePicker.vue" class="timepicker" :class="{ 'is-active': DisplayPicker, 'is-standalone': Standalone, 'is-fixed': !Standalone, 'is-disabled': Disabled, 'is-fluid': Fluid }" tabindex="0" @click="TogglePicker">
	<div v-if="!Standalone" class="relative">
		<input :value="Label" readonly>
		<div class="calendarSvg-container">
			<BaseIcon name="clock" size="1" class="text-neutral-700"/>
		</div>
	</div>
	<div v-if="DisplayPicker || Standalone " ref="PickerPopup" class="timepicker-popup" @click.stop>
		<div class="flex text-base w-full">
			<div class="col-half overflow-auto">
				<div v-for="i in 24" :key="i" class="p-1" :class="{ 'is-selected': Time[0] === i - 1 }" @click="SelectTime(i - 1, null)" v-html="(i <= 10 ? '0' : '') + (i - 1)"/>
			</div>
			<div v-if="!Quarter" class="col-half overflow-auto">
				<div v-for="i in 60" :key="i" class="p-1" :class="{ 'is-selected': Time[1] === i - 1 }" @click="SelectTime(null, i - 1)" v-html="(i <= 10 ? '0' : '') + (i - 1)"/>
			</div>
			<div v-else class="col-half overflow-auto py-2">
				<div v-for="i in 4" :key="i" class="px-1 py-4" :class="{ 'is-selected': Time[1] === (i - 1) * 15 }" @click="SelectTime(null, ((i - 1) * 15))" v-html="((i * 15) <= 10 ? '0' : '') + ((i - 1) * 15)"/>
			</div>
		</div>
	</div>
</div>
</template>

<script lang="ts">
// @vuese
// Komponent odpowiedzialny za kontrolkę wyboru czasu.
// TODO: Obsługa klawiatury
// @group Base Components | Forms
export default {
	name: 'TimePicker',
	props: {
		modelValue: {},
		Standalone: { default: false },
		Disabled: { type: Boolean, default: false },
		Fluid: { type: Boolean, default: false },
	},
	emits: ['update:modelValue'],
	data() {
		return {
			DisplayPicker: false,
			Time: [0, 0],
			Quarter: true,
		};
	},
	computed: {
		Label() { return this.modelValue; },
	},
	watch: {
		modelValue(n) {
			const t = n.split(':');
			this.Time = [Number(t[0]), Number(t[1])];
		},
		DisplayPicker() {
			window.setTimeout(() => {
				if (this.$refs.PickerPopup) {
					this.$refs.PickerPopup.querySelectorAll('.is-selected').forEach((el) => el.scrollIntoView({ block: 'center' }));
				}
			}, 25);
		},
	},
	created() {
		if (this.modelValue) {
			const t = this.modelValue.split(':');
			this.Time = [Number(t[0]), Number(t[1])];
		}
		if (!this.modelValue) {
			this.$emit('update:modelValue', '12:00');
		}
	},
	methods: {
		SelectTime(h, m) {
			if (h !== null) { this.Time[0] = h; }
			if (m !== null) { this.Time[1] = m; }
			const Pad = (n) => (n > 9 ? n : (`0${n}`));
			this.$emit('update:modelValue', `${Pad(this.Time[0])}:${Pad(this.Time[1])}`);
			window.setTimeout(() => { this.DisplayPicker = false; }, 50);
		},
		TogglePicker() {
			if (!this.Disabled) {
				this.DisplayPicker = !this.DisplayPicker;
			}
		}
	},
};

</script>

<style lang="scss">

.timepicker-popup {
	display: flex;
}

.timepicker-popup {
	.is-selected {
		color: var(--accent);
		font-weight: bold;
	}
}

.is-active {
	.timepicker-popup {
		position: absolute;
		z-index: 2;
	}
}

.timepicker {
	z-index: 1;
	outline: none !important;

	&:not(.is-fluid) {
		width: 182px;
	}

	input {
		padding: 0;
		border-bottom-right-radius: 0;
		border-top-right-radius: 0;
		pointer-events: none;
		text-align: center;
		touch-action: none;
	}

	.relative {
		display: flex;

		.calendarSvg-container {
			display: flex;
			width: 40px;
			height: auto;
			align-items: center;
			justify-content: center;
			border: 1px solid #ccc;
			border-left: none;
			background-color: #f3f4f7;
			border-radius: 0 4px 4px 0;
		}
	}
}
.timepicker:not(.is-disabled) {
	.relative {
		cursor: pointer;
	}

	&:hover input { color: var(--accent); }
}

.timepicker-popup {
	position: absolute;
	top: 0;
	right: 0;
	width: 240px;
	height: 240px;
	background: white;
	border-radius: 4px;
	box-shadow: 0 4px 4px 4px rgb(0 0 0 / 15%);
	box-shadow: 0 10px 24px 0 rgb(0 0 0 / 16%);
	text-align: center;
	user-select: none;
	white-space: normal;
}

.timepicker.is-fixed {
	.timepicker-popup {
		position: fixed;
		top: 50%;
		left: 50%;
		box-shadow: 0 10px 24px 0 rgb(0 0 0 / 16%), 0 0 0 100vmax rgb(0 0 0 / 15%);
		transform: translate(-50%, -50%);
	}

	&.is-active::before {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		content: '';
	}
}

.timepicker.is-fixed.is-active::before {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	content: '';
}

.timepicker.is-standalone .timepicker-popup {
	position: static;
	box-shadow: none;
}

.timepicker.is-active {
	z-index: 65555;
}
</style>
